<ng-template vdrDialogTitle>{{ "link.search-zone" | translate }}</ng-template>

<ng-select
  [items]="countries$ | async"
  appendTo="body"
  bindLabel="name"
  [addTag]="false"
  [multiple]="false"
  [hideSelected]="true"
  [trackByFn]="trackByFn"
  [minTermLength]="2"
  [loading]="isLoading"
  [typeahead]="input$"
  [(ngModel)]="selectedCountry"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear">
    <span class="item-row">
      <clr-icon shape="event" class="is-solid"></clr-icon
      ><span class="mx-1">{{ item.name }}</span>
    </span>
  </ng-template>
</ng-select>

<ng-template vdrDialogButtons>
  <button type="button" class="btn" (click)="cancel()">
    {{ "common.cancel" | translate }}
  </button>
  <button type="submit" (click)="select()" class="btn btn-primary">
    {{ "common.okay" | translate }}
  </button>
</ng-template>
